(ns minorodata.connections.sources.google-sheets
  (:require [minorodata.app.utils :as app.utils]))


(def source
  {:id           "google-sheets"
   :enabled      false
   :name         "Google Sheets (Legacy)"
   :description  "Google Sheets makes your data pop with colorful charts and graphs"
   :image-source "google-sheets.png"
   :tags         ["data-import"]

   :preview-formatter
   (fn [source]
     (str "Client: "
          (get-in source [:credentials :client-email])
          ", project: "
          (get-in source [:credentials :project-id])))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [client-email client-id private-key private-key-id project-id name description]} data]
        {:source-type "google-sheets"
         :name        name
         :description description

         :source
         {:credentials {:type           "service_account"
                        :client_email   client-email
                        :client_id      client-id
                        :private_key    private-key
                        :private_key_id private-key-id
                        :project_id     project-id}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:client-email :client-id :private-key :private-key-id :project-id]))))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.
    
    :validate (constantly nil)

    :id :google-sheets-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Client Email"
              :name       :client-email
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Client ID"
              :name       :client-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Private Key"
              :name       :private-key
              :type       :password
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Private Key ID"
              :name       :private-key-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Project ID"
              :name       :project-id
              :required   true
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action spreadsheet workbook destination-table]}]
      {:name          name
       :description   description
       :status        status
       :output-tables []

       :config
       {:extracts [{:spreadsheet       spreadsheet
                    :workbook          workbook
                    :action            action
                    :destination-table destination-table}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:spreadsheet :workbook :action :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :google-sheets-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :input
              :label      "Spreadsheet"
              :name       :spreadsheet
              :required   true
              :value      ""}

             {:block-type :input
              :label      "Workbook"
              :name       :workbook
              :required   true
              :value      ""}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
